<template>
  <div class="detail-dialog">
    <el-dialog :title="'师生互动' + detailType" :visible.sync="interactionDetailDialogShow" :close-on-click-modal="false"
      width="1000px" :before-close="dialogClose" @open="dialogOpen">
      <!-- 学年学期 -->
      <!-- <el-form :model="formData" :rules="rules" ref="formRef" label-width="100px" class="ruleForm"
        label-position="right" :inline="true">
        <el-form-item label="选择学年:" label-width="100px" prop="schoolYear">
          <year-range-picker style="width: 250px;" v-model="formData.studentInfo.schoolYear" />
        </el-form-item>
        <el-form-item label="选择学期:" label-width="100px" prop="semester">
          <el-select v-model="formData.studentInfo.semester" disabled placeholder="请选择学期" style="width: 235px">
            <el-option v-for="item in semesterOptions" :key="item.dictValue" :label="item.dictLabel"
              :value="item.dictValue">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form> -->
      <!-- 互动内容-结果 -->
      <!-- <el-form ref="ruleForm" label-width="100px" class="ruleForm" label-position="top">
        <el-form-item label="互动内容">
          <el-input type="textarea" disabled :autosize="{ minRows: 6, maxRows: 8 }"
            v-model="detailData.conversationContent" :maxlength="maxlength" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="互动结果">
          <el-input type="textarea" disabled :autosize="{ minRows: 6, maxRows: 8 }"
            v-model="detailData.conversationResult" :maxlength="maxlength" show-word-limit></el-input>
        </el-form-item>
      </el-form> -->
      <div class="record-form-container">
        <!-- <h3>学生基本信息</h3> -->
        <!-- <el-button size="small" type="success" @click="submitForm"
          style="position: absolute; top: 10px; right: 10px;">{{ '保存学生基本信息'
          }}</el-button> -->
        <el-form ref="formRef" :model="formData" label-width="120px" :rules="rules" label-position="top">

          <!-- 学生信息
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="学生姓名" prop="studentInfo.studentName">
                <el-input v-model="formData.studentInfo.studentName" disabled placeholder="请输入学生姓名" />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="性别" prop="studentInfo.sex">
                <el-input v-model="formData.studentInfo.sex" disabled placeholder="请输入性别" />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="年龄" prop="studentInfo.age">
                <el-input v-model="formData.studentInfo.age" disabled placeholder="请输入年龄" />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="所在班级" prop="studentInfo.className">
                <el-input v-model="formData.studentInfo.gradeClassName" disabled placeholder="请输入所在班级" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="家长姓名" prop="studentInfo.patriarchName">
                <el-input v-model="formData.studentInfo.patriarchName" disabled placeholder="请输入家长姓名" />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="与学生关系" prop="studentInfo.relationship">
                <el-input v-model="formData.studentInfo.relationship" disabled placeholder="请输入与学生关系" />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="联系电话" prop="studentInfo.patriarchPhone">
                <el-input v-model="formData.studentInfo.patriarchPhone" disabled placeholder="请输入联系电话" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="学生总体情况" prop="studentInfo.overview">
            <el-input type="textarea" v-model="formData.studentInfo.overview" disabled :rows="4" show-word-limit
              maxlength="1000" placeholder="请输入学生总体情况" />
          </el-form-item> -->

          <!-- 谈话记录 -->
          <h3>谈话备忘记录</h3>
          <!-- <el-button type="primary" @click="addRecord">+ 添加记录</el-button> -->

          <div
            style="margin-top: 20px; border: 1px solid #0066cc; padding: 15px; border-radius: 4px; position: relative;">
            <!-- <h4>谈话备忘记录</h4> -->
            <div v-if="detailType == '修改'" style="position: absolute; top: 10px; right: 10px; z-index: 9999;">
              <el-button size="mini" type="success" style="margin-right: 10px;"
                @click="submitSingleRecord(formData.studentInfo)">提交修改</el-button>
              <!-- <el-button size="mini" type="danger" @click="removeRecord(formData.studentInfo)">删除</el-button> -->
            </div>

            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="谈话时间" prop="studentInfo.interactTime">
                  <el-date-picker v-model="formData.studentInfo.interactTime" type="date" value-format="yyyy-MM-dd"
                    placeholder="请选择日期" style="width: 100%" />
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="地点" prop="studentInfo.interactLocation">
                  <el-input v-model="formData.studentInfo.interactLocation" placeholder="请输入地点" />
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="谈话内容" prop="studentInfo.interactContent">
              <el-input type="textarea" v-model="formData.studentInfo.interactContent" :rows="4"
                placeholder="请输入谈话内容" />
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="btn-list">
        <!-- <el-button type="primary" @click="submitSingleRecord">提交修改</el-button> -->
        <el-button type="primary" @click="finish">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";

import { baseURL } from "@/api/request"; // 服务器地址
export default {
  props: [
    'interactionDetailDialogShow',
    'detailData',
    'semesterOptions',
    'talkStudentInfo',
    'teacherId',
    'teacherName',
    'studentInfo',
    'talkRecordDetailsList',
    'detailType'
  ],
  data() {
    return {
      maxlength: 1000,
      formData: {
        studentInfo: {
          // 学生基本信息（可选，如果后端返回）
          studentName: '',
          sex: '',
          age: '',
          gradeClassName: '', // 注意：模板里用的是 gradeClassName，不是 className
          patriarchName: '',
          relationship: '',
          patriarchPhone: '',
          overview: '',

          // 谈话记录字段（重点！）
          interactTime: '',
          interactLocation: '',
          interactContent: ''
        }
      },
      action: "", // 文件上传路径
      rules: {
        'studentInfo.interactTime': [
          { required: true, message: '请选择谈话时间', trigger: 'change' } // 注意：日期选择器用 change 触发更合适
        ],
        'studentInfo.interactLocation': [
          { required: true, message: '请输入谈话地点', trigger: 'blur' }
        ],
        'studentInfo.interactContent': [
          { required: true, message: '请输入谈话内容', trigger: 'blur' }
        ],
        'studentInfo.studentName': [
          { required: true, message: '请输入学生姓名', trigger: 'blur' }
        ],
        'studentInfo.sex': [
          { required: true, message: '请输入性别', trigger: 'blur' }
        ],
        'studentInfo.age': [
          { required: true, message: '请输入年龄', trigger: 'blur' }
        ],
        'studentInfo.className': [
          { required: true, message: '请输入所在班级', trigger: 'blur' }
        ],
        'studentInfo.patriarchName': [
          { required: true, message: '请输入家长姓名', trigger: 'blur' }
        ],
        'studentInfo.relationship': [
          { required: true, message: '请输入与学生关系', trigger: 'blur' }
        ],
        'studentInfo.patriarchPhone': [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式错误', trigger: 'blur' }
        ],
        'studentInfo.overview': [
          { required: true, message: '请输入学生总体情况', trigger: 'blur' }
        ]
      },
    };
  },
  mounted() {
    this.action = `${baseURL}${this.$url.editTeacherStudentInteract}`;
    this.formData = {
      studentInfo: {
        ...this.detailData,
        interactTime: this.convertToDate(this.detailData.interactTime),
      },
      // record: {
      //   ...this.detailData,
      //   interactTime: this.convertToDate(this.detailData.interactTime)
      // }
    };
    // console.log("this.formData", this.formData)
  },
  methods: {
    removeRecord(row) {
      this.$confirm("是否删除该记录?", "删除", {
        confirmButtonText: "确定",
        cancelButtomText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          this.delete(this.$url.deleteTeacherStudentInteract + '?id=' + row.id).then((res) => {
            if (res.code !== 200) return this.$message.error(res.msg);
            this.$message.success(res.msg);
            this.$emit("selectTalkRecordDetailsList", this.detailData.id);
          });
        })
        .catch(() => { });
    },
    // 开启弹窗
    dialogOpen() {
    },
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("refresh");
      this.$emit("update:interactionDetailDialogShow", false);
    },
    finish() {
      this.dialogClose();
    },
    submitSingleRecord(item) {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          // 提交逻辑
          let data = {
            "interactTime": item.interactTime,
            "interactContent": item.interactContent,
            "interactLocation": item.interactLocation,
            "id": item.id,
            "talkrecordMainId": item.talkrecordMainId,
            "teacherId": this.teacherId,
            "teacherName": this.teacherName,
          };
          // 创建 FormData 并填充数据
          let formData = new FormData();
          Object.entries(data).forEach(([key, value]) => {
            if (value !== null && value !== undefined) {
              formData.append(key, value);
            }
          });

          let config = {
            headers: {
              bbfAdminTeacherToken: window.localStorage.getItem("bbfAdminTeacherToken"),
              "Content-Type": "multipart/form-data",
            },
          };
          // 调用接口
          axios
            .post(this.action, formData, config)
            .then((res) => {
              this.count = 1;
              // res.data 服务器返回的数据
              let data = res.data;
              // console.log(res);
              if (data.code == 200) {
                this.$message.success(data.msg);
                return;
              } else if (data.code == 401 || data.code == 403) {
                // token失效
                this.$message.error("获取用户信息失败，请重新登录");
                this.$store.dispatch("user/resetToken");
                this.$router.replace({
                  path: "login",
                  query: { redirect: this.$router.currentRoute.fullPath },
                });
              } else {
                this.$message.error(data.msg);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
      // this.put(this.$url.editTeacherStudentInteract, data).then(res => {
      //   if (res.code == 200) {
      //     this.$message.success(res.msg);
      //     // this.$emit("refresh");
      //     // this.dialogClose();
      //   } else {
      //     this.$message.error(res.msg);
      //   }
      // })
    },
    convertToDate(dateStr) {
      const match = dateStr.match(/(\d{4})年(\d{2})月(\d{2})日/);
      if (match) {
        const year = match[1];
        const month = match[2];
        const day = match[3];
        return `${year}-${month}-${day}`;
      }
      return '';
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./interactionDetailDialog.scss";
</style>